import { useState } from 'react';
import Button from 'components/ui-components/Button';
import { Arrow } from 'assets/icons';
import MFAOptOutModal from 'components/mfa/opt_out/optOutModal';

import { white } from 'constants/variables';

const MFAToggle = ({ mfaEnabled, mfaEnableUrl }) => {
  const [disableModalOpen, setDisableModalOpen] = useState(false);

  const onClick = () => {
    if (mfaEnabled) {
      setDisableModalOpen(true);
    } else {
      window.location.href = mfaEnableUrl;
    }
  };

  return (
    <>
      <Button
        type="button"
        handleClick={onClick}
        className="cef-btn cef-btn--small-feature cef-btn--grey pl-16 pr-16">
        <span className="mr-19">{mfaEnabled ? 'Turn off' : 'Turn on'}</span>
        <Arrow fillColor={white} />
      </Button>
      <MFAOptOutModal
        modalOpen={disableModalOpen}
        closeModal={() => setDisableModalOpen(false)}
      />
    </>
  );
};

export default MFAToggle;
